import api from '../utils/api';

/**
 * Service pour interagir avec l'API Qonto
 */
class QontoService {
  /**
   * Récupère le solde du compte Qonto
   * @returns {Promise<Object>} Le solde du compte et les informations associées
   */
  async getAccountBalance() {
    try {
      const response = await api.get('/api/qonto/balance');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du solde Qonto:', error);
      throw error;
    }
  }

  /**
   * Récupère les transactions récentes du compte Qonto
   * @param {Object} params Paramètres optionnels (dates, limite, etc.)
   * @returns {Promise<Array>} Liste des transactions
   */
  async getTransactions(params = {}) {
    try {
      const response = await api.get('/api/qonto/transactions', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des transactions Qonto:', error);
      throw error;
    }
  }
}

export default new QontoService(); 